import React from 'react';
import './DojoNudge.css';

// A small, dismissible nudge shown in the activity feed when the user is not
// yet a member of any dojo. Encourages joining or creating one. Two dismissal
// levels:
//   - Close (×): hidden for this session/until next load.
//   - "Don't show again": persisted to localStorage, suppressed permanently.
const DojoNudge = ({ onJoinOrCreate, userId }) => {
  const [dismissed, setDismissed] = React.useState(false);
  // Permanently suppress per-user so it doesn't nag after the user opts out.
  const suppressKey = React.useMemo(
    () => (userId ? `dojo_nudge_suppressed_${userId}` : null),
    [userId]
  );
  const [suppressed, setSuppressed] = React.useState(
    () => suppressKey && window.localStorage.getItem(suppressKey) === '1'
  );

  const handleNeverShowAgain = () => {
    if (suppressKey) window.localStorage.setItem(suppressKey, '1');
    setSuppressed(true);
  };

  if (suppressed || dismissed) return null;

  return (
    <div className="dojo-nudge" role="complementary" aria-label="Join a dojo">
      <button
        className="dojo-nudge-close"
        aria-label="Dismiss"
        onClick={() => setDismissed(true)}
      >
        ×
      </button>
      <div className="dojo-nudge-icon" aria-hidden="true">🥋</div>
      <div className="dojo-nudge-body">
        <h3>Train together</h3>
        <p>
          Join or create a dojo to train with others, share activity, and
          climb the leaderboard together.
        </p>
        <div className="dojo-nudge-actions">
          <button className="dojo-nudge-cta" onClick={onJoinOrCreate}>
            Join or Create a Dojo
          </button>
          <button
            className="dojo-nudge-never"
            onClick={handleNeverShowAgain}
          >
            Don't show this again
          </button>
        </div>
      </div>
    </div>
  );
};

export default DojoNudge;